import React from 'react';
import { IProps as IBlockProps } from './HeroBannerBlock.interface';
import { IProps as IButtonProps } from '@/elements/Button/Button.interface';
import { HeroBannerBlock } from './HeroBannerBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface IBlockInputProps {
    backButton?: any;
    heading?: string;
    content?: string;
    buttons?: any;
    parentClass?: string;
    anchorId?: string;
    image?: any;
    background: ThemeColors;
    [key: string]: any; // Allow passthrough of other props
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const {
        backButton,
        background,
        heading,
        content,
        parentClass,
        image,
        anchorId,
        buttons,
        ...rest
    } = input;

    return {
        backButton: backButton ? translation.mapAnchorProps(backButton) : undefined,
        title: heading,
        description: content,
        buttons: buttons?.map(
            (button: any) => translation.mapAnchorProps(button) as IButtonProps,
        ),
        backgroundColor: background || 'white',
        backgroundGradient: 'gradient-1',
        backgroundImage: image ? translation.mapImageProps(image) : undefined,
        paddingBottom: 'small',
        paddingTop: 'small',
        ...rest,
    };
};

const BlockTranslation: React.FC<IBlockInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={HeroBannerBlock}
        mapProps={mapInputToProps}
    />
);

export default BlockTranslation;
